import React, { Component } from "react";
import { SSOApp } from "../../typings/global";
import { EIDAClientProfile } from "@eres/ssoapi/entities";

export enum Step {
	app,
	eid,
	confirm,
	verify,
	profile_confirm,
	uid,
	done
}

export type RegType = "eida" | "uaepass";

export interface ISSORegData {
	mode: RegType;
	app?: SSOApp;
	eid?: string;
	profile?: EIDAClientProfile;
	step: Step;
	newEmail?: string;
}

export interface ISSORegContext extends ISSORegData {
	update?: ( data: Partial<ISSORegData> ) => void;
}

interface Props {
}

const defaultContext: ISSORegContext = {
	mode: "eida",
	step: Step.app,
};

export const SSORegContext = React.createContext( defaultContext );

interface State extends ISSORegContext {
}

class SSORegContextWrapper extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			mode: "eida",
			step: Step.app,
			update: ( data => this.setState( data as State ) ),
		};
	}

	render() {
		return <SSORegContext.Provider value={ { ...this.state } }>
			{ this.props.children }
		</SSORegContext.Provider>;
	}
}


export default SSORegContextWrapper;
